// Single source of truth for the env vars environment.ts fails fast on and vite.config.js
// enforces at build time — keeps the two enforcement points from drifting apart.
// ADR-0031: every variable is required and has no default in code. Each one is one of three kinds:
// - required: must be set and non-empty.
// - optional: the key must be set; an empty value turns the feature off.
// - flag: must be exactly "true" or "false".
export const REQUIRED_ENV_VARS = [
	"REACT_APP_APP_ENVIRONMENT",
	"REACT_APP_APP_VARIANT",
	"REACT_APP_APP_TITLE",
	"REACT_APP_API_BASE",
	"REACT_APP_WS_API_BASE",
	"REACT_APP_WEB_BASE",
	"REACT_APP_SUPABASE_URL",
	"REACT_APP_SUPABASE_ANON_KEY",
];

export const OPTIONAL_ENV_VARS = ["REACT_APP_SENTRY_DSN"];

export const REQUIRED_BOOLEAN_FLAGS = ["REACT_APP_HAS_MOBILE_APP"];

/**
 * @param {Record<string, unknown>} env
 * @returns {string[]}
 */
export const getInvalidBooleanFlags = (env) =>
	REQUIRED_BOOLEAN_FLAGS.filter((key) => env[key] !== "true" && env[key] !== "false");

/**
 * Every problem with the given env, one message per bad variable, so a single error can list them all.
 *
 * @param {Record<string, unknown>} env
 * @returns {string[]}
 */
export const getEnvErrors = (env) => [
	...REQUIRED_ENV_VARS.filter((key) => !env[key]).map((key) => `${key} is missing or empty`),
	...OPTIONAL_ENV_VARS.filter((key) => env[key] === undefined).map(
		(key) => `${key} is missing (set it empty to turn it off)`,
	),
	...getInvalidBooleanFlags(env).map((key) => `${key} must be "true" or "false"`),
];
